import { render } from "./index.vue?vue&type=template&id=3a96dd9a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3a96dd9a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a96dd9a"],['__file',"src/views/oa/patrolRecord/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a96dd9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a96dd9a', __exports__)) {
    console.log('reload')
    api.reload('3a96dd9a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3a96dd9a&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a96dd9a', render)
  })

}


export default __exports__